import { array, boolean, object, string } from 'yup';
import {
  CommunicationSendStatus,
  NewCommunication,
} from '../../../types/communication';
import { pkValidation } from '../../../utils/pkValidation';
import i18n from '../../../i18n';
import { PK_FORMAT_REGEX } from '../../../utils/transform';

export const createCommunicationSchema = (directionRequired: boolean) => object<NewCommunication>({
  operator: string().required(),
  registerInitDate: string().required(),
  groupInter: string().required(),
  media: string().required(),
  sendStatus: string()
    .oneOf([CommunicationSendStatus.SENT, CommunicationSendStatus.RECEIVED])
    .required(),
  concession: string().required(),
  city: string().required(),
  pkInitRoad: string().required(),
  pkEndRoad: string().required(),
  road: string().required(),
  track: string().required(),
  direction: directionRequired
    ? string().required(() => i18n.t('validation:required'))
    : string().nullable().optional(),
  lane: string().required(),
  pkInit: string()
    .matches(PK_FORMAT_REGEX)
    .test(function (value) {
      return PK_FORMAT_REGEX.test(value || '') && pkValidation(value || '', this.parent);
    })
    .required(),
  pkEnd: string()
    .test(function (value) {
      return PK_FORMAT_REGEX.test(value || '') && pkValidation(value || '', this.parent);
    })
    .required(),
  description: string().required(() =>
    i18n.t('validation:required', { field: i18n.t('common:labels.description') })
  ),
  notes: string().notRequired(),
  isValidate: boolean(),
  capitol: string().required(),
  subCapitol: string().required(),
  classification: string().required(),
  predefine: string().required(() => i18n.t('validation:required')),
  teamRelationships: array().of(string()).notRequired(),
  relateOT: object().when(
    ['$index', '$dataOT'],
    ([index, dataOT], schema) =>
      index === 1 && !dataOT
        ? schema.required(() => i18n.t('validation:required'))
        : schema.notRequired()
  ),
  relateCampaign: object().when(
    ['$index', '$dataOT'],
    ([index, dataOT], schema) =>
      index === 2 && !dataOT
        ? schema.required(() => i18n.t('validation:required'))
        : schema.notRequired()
  ),
  specialTag: string(),
});

// Backward compat: default schema con direction required
export const newCommunicationSchema = createCommunicationSchema(true);
